import type { GdprConfig } from 'src/app/pages/petitionDetails/shared/hooks';
import type { FormValues, NormalizedFormValues } from 'src/app/pages/petitionDetails/shared/types';

import { isGdprEnabled } from '../isGdprEnabled';

export function normalizeGdprConsent(
	{ countryCode, gdprConsent }: Pick<FormValues, 'countryCode' | 'gdprConsent'>,
	gdprConfig: GdprConfig,
): NormalizedFormValues['marketingCommsConsent'] {
	const gdpr = isGdprEnabled(countryCode, gdprConfig);
	const { copy, overridden } = gdprConfig;
	return gdpr
		? {
				consentGiven: gdprConsent === 'true',
				name: overridden ? 'global_consent_initial_eu_exp_control' : 'global_consent_initial_eu_default',
				text: copy.prompt || copy.opt_in,
			}
		: null;
}
